import axios from 'axios'
import CustomersService from '../redux/middlewares/customers'

export const syncCustomerSapCode = (id) => CustomersService.syncCustomerSapCode(id)
export const syncCustomerBookletCoupons = async (id) => {
  const response = await axios({
    url: `users/${id}/sync-booklet-coupons`,
    method: 'POST',
  })
  return response.data?.data
}

